"use client"

import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import {
  getCurrentAppPath,
  redirectToAppPath,
  enforceAdminSessionTimeout,
  isAdminSessionToken,
  touchAdminSessionActivity,
} from "../utils/adminSession"

const CHECK_INTERVAL_MS = 15000
const ACTIVITY_EVENTS = ["pointerdown", "keydown", "touchstart", "scroll", "focus"]

function AdminSessionGuard() {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (!enforceAdminSessionTimeout()) return
    if (location.pathname !== "/login") {
      navigate("/login", { replace: true })
    }
  }, [location.pathname, navigate])

  useEffect(() => {
    const token = localStorage.getItem("token")
    if (!token || !isAdminSessionToken(token)) return undefined

    const forceLogoutIfExpired = () => {
      if (!enforceAdminSessionTimeout()) return false
      if (getCurrentAppPath() !== "/login") {
        redirectToAppPath("/login")
      }
      return true
    }

    const onActivity = () => {
      if (forceLogoutIfExpired()) return
      touchAdminSessionActivity()
    }

    ACTIVITY_EVENTS.forEach((eventName) => {
      window.addEventListener(eventName, onActivity, { passive: true })
    })

    const timerId = window.setInterval(forceLogoutIfExpired, CHECK_INTERVAL_MS)
    onActivity()

    return () => {
      window.clearInterval(timerId)
      ACTIVITY_EVENTS.forEach((eventName) => {
        window.removeEventListener(eventName, onActivity)
      })
    }
  }, [location.pathname])

  return null
}

export default AdminSessionGuard
